import React from "react";

import PriceCard from "./PriceCard";
import Title from "../../../components/Title";
import Spacer from "../../../components/Spacer";
import Section from "../../../components/Section";
import ContentGrid from "../../../components/ContentGrid";

import style from "./style.module.css";

export default function PlanList(props) {
    const {
        sub_title = "",
        title = "",
        plans = [],
    } = props;

    return (
        <Section className={style.planList}>
            <div className={style.planListWrap}>
                <div className={style.sectionRow}>
                    {
                        (sub_title !== "" || title !== "") && (
                            <div className={style.sectionHeader}>
                                {
                                    sub_title !== "" && (
                                        <Title tag="h6">{sub_title}</Title>
                                    )
                                }
                                {
                                    title !== "" && (
                                        <Title className="fontTeko" tag="h1">{title}</Title>
                                    )
                                }
                            </div>
                        )
                    }
                    <div className={style.sectionBody}>
                        <Spacer size="24" />
                        <ContentGrid
                            items={plans}
                            wrap={1}
                            Component={PriceCard}
                            col={"col3"}
                        />
                    </div>
                </div>
            </div>
        </Section>
    )
}